// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--cgS9P";
export var Title = "styles-module--Title--2wJEW";
export var Description = "styles-module--Description--ZEPXN";
export var Content = "styles-module--Content--1eGYU";